'use strict';

var urlBuilder = require('./url-builder');
var device = require('./device');
var dom = require('./dom');

var init = function() {

	device.init();

};

module.exports = {
	init: init,
	dom: dom,
	getUrl: urlBuilder.get,
	getDeviceState: device.getState,
	wasDeviceUpsized: device.wasUpsized,
	wasDeviceDownsized: device.wasDownsized,
	supports: device.supports
};
